import React from 'react'

function Gadget() {
  return (
    <div>Gadget</div>
  )
}

export default Gadget